<template>
  <el-container style="height: 100vh;">
    <el-aside width="200px" style="background-color: #001529;">
      <div style="height: 60px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 18px; font-weight: bold;">
        <img src="@/images/ryzs_logo.png" style="height: 32px; margin-right: 8px;" alt="logo" />
        <span>如易智算后台</span>
      </div>
      <el-menu
        :default-active="$route.path"
        background-color="#001529"
        text-color="#fff"
        active-text-color="#ffd04b"
        router>
        <el-menu-item index="/dashboard">
          <i class="el-icon-s-home"></i>
          <span slot="title">仪表盘</span>
        </el-menu-item>
        <el-menu-item index="/students">
          <i class="el-icon-user-solid"></i>
          <span slot="title">学生管理</span>
        </el-menu-item>
        <el-menu-item index="/levels">
          <i class="el-icon-s-operation"></i>
          <span slot="title">关卡配置</span>
        </el-menu-item>
        <el-menu-item index="/questions">
          <i class="el-icon-document"></i>
          <span slot="title">题库记录</span>
        </el-menu-item>
        <el-menu-item index="/wrong-questions">
          <i class="el-icon-warning-outline"></i>
          <span slot="title">错题记录</span>
        </el-menu-item>
        <el-menu-item index="/attempts">
          <i class="el-icon-edit-outline"></i>
          <span slot="title">答题明细</span>
        </el-menu-item>
        <el-menu-item index="/visits">
          <i class="el-icon-view"></i>
          <span slot="title">访问日志</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="text-align: right; font-size: 12px; border-bottom: 1px solid #eee; display: flex; align-items: center; justify-content: flex-end;">
        <el-dropdown>
          <span class="el-dropdown-link" style="cursor: pointer;">
            管理员 <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import api from '@/api';

export default {
  methods: {
    logout() {
      api.clearToken();
      this.$router.push('/login');
    }
  }
}
</script>

<style>
.el-header {
  background-color: #fff;
  color: #333;
  line-height: 60px;
}
</style>
